var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSearch,
              expression: "showSearch",
            },
          ],
          ref: "queryForm",
          attrs: {
            model: _vm.queryParams,
            size: "small",
            inline: true,
            "label-width": "78px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "账号类型" } },
            [
              _c(
                "el-select",
                {
                  attrs: { multiple: "", "collapse-tags": "" },
                  model: {
                    value: _vm.queryParams.accountType,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "accountType", $$v)
                    },
                    expression: "queryParams.accountType",
                  },
                },
                _vm._l(_vm.accountTypeMap, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "用户查询" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "35%" },
                      attrs: { clearable: "" },
                      on: {
                        change: function ($event) {
                          _vm.queryParams.userQueryStr = ""
                        },
                      },
                      model: {
                        value: _vm.queryParams.userQueryEnum,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "userQueryEnum", $$v)
                        },
                        expression: "queryParams.userQueryEnum",
                      },
                    },
                    _vm._l(_vm.userQueryEnumMap, function (val, key) {
                      return _c("el-option", {
                        key: key,
                        attrs: { label: val, value: key },
                      })
                    }),
                    1
                  ),
                  _c("el-input", {
                    staticStyle: { width: "65%" },
                    attrs: { placeholder: "请输入内容", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleQuery.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.queryParams.userQueryStr,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "userQueryStr", $$v)
                      },
                      expression: "queryParams.userQueryStr",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "角色" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入角色", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleQuery.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.queryParams.fuzzyRoleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "fuzzyRoleName", $$v)
                  },
                  expression: "queryParams.fuzzyRoleName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-search",
                    size: "mini",
                  },
                  on: { click: _vm.handleQuery },
                },
                [_vm._v(" 搜索 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", size: "mini" },
                  on: { click: _vm.resetQuery },
                },
                [_vm._v(" 重置 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-row", {
        staticClass: "mb8",
        attrs: { gutter: 10, type: "flex", justify: "end" },
      }),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { "margin-top": "10px" },
          attrs: { data: _vm.userList },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "操作",
              align: "center",
              "class-name": "small-padding fixed-width",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "text",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleClickSee(row)
                          },
                        },
                      },
                      [_vm._v(" 查看 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["userList_edit"],
                            expression: "['userList_edit']",
                          },
                        ],
                        attrs: {
                          size: "mini",
                          type: "text",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleUpdate(row)
                          },
                        },
                      },
                      [_vm._v(" 权限 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              align: "center",
              prop: "enable",
              width: "50px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: row.enable ? "" : "danger" } },
                      [_vm._v(" " + _vm._s(row.enable ? "启用" : "禁用") + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "账号类型", align: "center", prop: "accountType" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.accountTypeToText(row.accountType)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "账号名", align: "center", prop: "account" },
          }),
          _c("el-table-column", {
            attrs: { label: "用户名", align: "center", prop: "name" },
          }),
          _c("el-table-column", {
            attrs: { label: "手机号码", align: "center", prop: "phoneNumber" },
          }),
          _c("el-table-column", {
            attrs: { label: "邮箱", align: "center", prop: "email" },
          }),
          _c("el-table-column", {
            attrs: { label: "角色", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          row.userRoles
                            ? row.userRoles
                                .map(function (item) {
                                  return item.roleName
                                })
                                .join(",")
                            : ""
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "描述",
              align: "center",
              prop: "description",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "操作人", align: "center", prop: "updateUser" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作时间", align: "center", prop: "updateTime" },
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.queryParams.current,
          limit: _vm.queryParams.size,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "current", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "size", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.open,
            width: "500px",
            "append-to-body": "",
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "currentUserForm",
              attrs: {
                model: _vm.currentUser,
                rules: _vm.rules,
                "label-width": "100px",
                disabled: "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "账号类型" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.currentUser.accountType,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentUser, "accountType", $$v)
                        },
                        expression: "currentUser.accountType",
                      },
                    },
                    _vm._l(_vm.accountTypeMap, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "账号名" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.currentUser.account,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentUser, "account", $$v)
                      },
                      expression: "currentUser.account",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户名" } },
                [
                  _c("el-input", {
                    attrs: { autosize: { minRows: 2, maxRows: 4 } },
                    model: {
                      value: _vm.currentUser.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentUser, "name", $$v)
                      },
                      expression: "currentUser.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手机号码" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.currentUser.phoneNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentUser, "phoneNumber", $$v)
                      },
                      expression: "currentUser.phoneNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.currentUser.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentUser, "email", $$v)
                      },
                      expression: "currentUser.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { disabled: "", label: true },
                      model: {
                        value: _vm.currentUser.enable,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentUser, "enable", $$v)
                        },
                        expression: "currentUser.enable",
                      },
                    },
                    [_vm._v("启用")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { disabled: "", label: false },
                      model: {
                        value: _vm.currentUser.enable,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentUser, "enable", $$v)
                        },
                        expression: "currentUser.enable",
                      },
                    },
                    [_vm._v("禁用")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取 消")]),
              _c(
                "el-button",
                {
                  directives: [{ name: "re-click", rawName: "v-re-click" }],
                  attrs: { type: "primary" },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.cancel.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" 确 定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑权限",
            visible: _vm.rolesForm,
            width: "500px",
            "append-to-body": "",
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.rolesForm = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "roleIds", label: "角色" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { multiple: "" },
                      model: {
                        value: _vm.form.roleIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "roleIds", $$v)
                        },
                        expression: "form.roleIds",
                      },
                    },
                    _vm._l(_vm.roleList, function (role) {
                      return _c("el-option", {
                        key: role.id,
                        attrs: { label: role.roleName, value: role.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { prop: "shopCodes", label: "门店权限" },
                  model: {
                    value: _vm.form.shopCodes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "shopCodes", $$v)
                    },
                    expression: "form.shopCodes",
                  },
                },
                [
                  _c("treeselect", {
                    attrs: {
                      multiple: true,
                      limit: 2,
                      options: _vm.shopOptions,
                      limitText: _vm.limitText,
                      placeholder: "选择门店",
                      noChildrenText: "无数据",
                      normalizer: _vm.normalizer,
                    },
                    on: {
                      close: _vm.handleCloseTree,
                      select: _vm.handleSelect,
                      deselect: _vm.handleDeselect,
                    },
                    model: {
                      value: _vm.shopCode,
                      callback: function ($$v) {
                        _vm.shopCode = $$v
                      },
                      expression: "shopCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "描述", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rolesForm = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  directives: [{ name: "re-click", rawName: "v-re-click" }],
                  attrs: { type: "primary" },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.submitForm.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" 确 定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("upload-file", {
        ref: "import",
        attrs: {
          title: "导入用户",
          tips: "只能上传xls,xlsx文件",
          accept: ".xls,.xlsx",
          enableDownloadTemplate: true,
          "append-to-body": true,
          api: _vm.importApi,
          "upload-sucess": _vm.getList,
          "download-api": _vm.handleDownloadImportTemp,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }